export interface IAuthenticationFailure {
  count: number;
  message: string;
}
